import React from 'react';
import DOMPurify from 'isomorphic-dompurify';
import TinyMceEditor from '../../components/TinyMce/TinyMce';
import { stripHtml } from './blogHtml';

const hasValue = value => value != null && typeof value === 'string' && value.trim().length > 0;
const hasHtml = value => /<\/?[a-z][\s\S]*>/i.test(value || '');
const hasBlockHtml = value => /<(p|ul|ol|li|blockquote|h[1-6]|div|table)\b/i.test(value || '');

const RichTextDisplay = ({ tag: Tag = 'p', value, className, css }) => {
  if (!hasValue(value)) return null;

  if (!hasHtml(value)) {
    return <Tag className={className}>{value}</Tag>;
  }

  const displayTag = (Tag === 'p' || Tag === 'span' || Tag === 'strong') && hasBlockHtml(value) ? 'div' : Tag;
  const classes = [css?.richTextContent, className].filter(Boolean).join(' ');
  const DisplayTag = displayTag;

  return <DisplayTag className={classes} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(value) }} />;
};

const EditableRichField = ({
  css,
  tag: Tag = 'p',
  value,
  onChange,
  isEditMode,
  className,
  multiline = false,
  placeholder = '',
}) => {
  if (!isEditMode && !hasValue(value)) return null;

  if (isEditMode && multiline) {
    const classes = [css?.richEditorField, className].filter(Boolean).join(' ');

    return (
      <div className={classes}>
        <TinyMceEditor
          value={value || ''}
          onChange={onChange}
          height={220}
          toolbar="undo redo | styles | bold italic | bullist numlist | outdent indent | link | removeformat"
          init={{
            menubar: false,
            statusbar: false,
            placeholder,
          }}
        />
      </div>
    );
  }

  if (isEditMode) {
    return (
      <Tag className={className}>
        <input
          className={css.editableInput}
          type="text"
          value={value || ''}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder}
        />
      </Tag>
    );
  }

  return <RichTextDisplay tag={Tag} value={value} className={className} css={css} />;
};

export default EditableRichField;
export { stripHtml };
